import { EventSubscriber, EntitySubscriberInterface, InsertEvent, UpdateEvent } from 'typeorm'

import { pubsub, getRepository } from '@things-factory/shell'

import { PlayGroup } from './play-group.js'

@EventSubscriber()
export class PlayGroupSubscriber implements EntitySubscriberInterface<PlayGroup> {
  listenTo() {
    return PlayGroup
  }

  // afterInsert(event: InsertEvent<PlayGroup>): Promise<any> | void {
  //   const playGroup = event.entity

  //   pubsub.publish('playGroup', {
  //     playGroup
  //   })
  // }

  async afterUpdate(event: UpdateEvent<PlayGroup>): Promise<any> {
    var playGroup = event.entity

    playGroup = await getRepository(PlayGroup).findOne({
      where: { domain: { id: playGroup.domainId }, id: playGroup.id },
      relations: ['domain', 'boards']
    })

    if (!playGroup) {
      return
    }

    playGroup.boards = playGroup.boards.sort((a, b) => {
      // 배열 A에 포함된 아이디의 순서를 가져옵니다.
      const indexOfOrder = (playGroup.order || []).indexOf(a.id)
      const indexOfBoards = (playGroup.order || []).indexOf(b.id)

      // 두 아이디의 순서를 비교하여 정렬합니다.
      if (indexOfOrder === -1 && indexOfBoards === -1) {
        // 두 아이디 모두 배열 A에 없는 경우, 그대로 유지합니다.
        return 0
      } else if (indexOfOrder === -1) {
        // 아이디 A만 배열 A에 없는 경우, 아이디 B를 먼저 정렬합니다.
        return 1
      } else if (indexOfBoards === -1) {
        // 아이디 B만 배열 A에 없는 경우, 아이디 A를 먼저 정렬합니다.
        return -1
      } else {
        // 두 아이디 모두 배열 A에 있는 경우, 배열 A의 아이디 순서대로 정렬합니다.
        return indexOfOrder - indexOfBoards
      }
    })

    pubsub.publish('play-group', {
      playGroup
    })
  }
}
